import { CsI18n } from "../shared/csI18n/csI18n";
import { MinusMinor, PlusMinor } from "@shopify/polaris-icons";
import React from "react";
import { Button, Icon } from "@shopify/polaris";

const ResourceListHelper = {
  itemAction(name, index, handleRemove, readonly = false, forceRemove = false) {
    return (readonly || (!forceRemove && index < 1)) ? '' : [{
      content: CsI18n.t('Remove'),
      accessibilityLabel: CsI18n.t('Remove'),
      icon: MinusMinor,
      onAction: handleRemove(name, index)
    }];
  },

  addNewAction(name, handleAdd) {
    return (
      <Button icon={<Icon source={PlusMinor} color="skyDark" />} onClick={handleAdd(name)} outline>
        <CsI18n>Add</CsI18n>
      </Button>
    );
  }
};

export default ResourceListHelper;